import { render, staticRenderFns } from "./cancel.vue?vue&type=template&id=3f6cb706&scoped=true"
import script from "./cancel.vue?vue&type=script&lang=js"
export * from "./cancel.vue?vue&type=script&lang=js"
import style0 from "./cancel.vue?vue&type=style&index=0&id=3f6cb706&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6cb706",
  null
  
)

export default component.exports